import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Injector, OnInit } from '@angular/core';
import { DevicesClass } from '@app/core/classes';
import { RolesService } from '@app/core/services';
import { AccountService } from '@app/modules/account-modules/account.service';
import { AccountStoryService } from '@app/modules/account-modules/account.story';
import {
  hasBookingIndividualCustomerAccount,
  hasBookingVenueCustomerAccount,
  hasMusicianAccountProfile
} from '@app/modules/account-modules/account.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'app-profile-account-router',
  templateUrl: './profile-account-router.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileAccountRouterComponent extends DevicesClass implements OnInit {
  showVenueBookingProfile = false;
  showUserProfile = true;

  constructor(
    injector: Injector,
    public cdr: ChangeDetectorRef,
    private roles: RolesService,
    private account: AccountService,
    private accountStory: AccountStoryService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.applyProfileVisibility({ profiles: this.roles.accountProfiles });
    this.accountStory.AccountEventBus$.pipe(untilDestroyed(this)).subscribe(emit => {
      if (emit.event === 'onAccountUpdate' && emit.data) {
        this.applyProfileVisibility(emit.data);
      }
    });
    if (!this.roles.accountProfiles?.length) {
      this.account
        .getMyInfo()
        .pipe(take(1), untilDestroyed(this))
        .subscribe(user => {
          this.account.onSetUserRole(user);
          this.applyProfileVisibility(user);
        });
    }
  }

  private applyProfileVisibility(user: { profiles?: unknown[] } | null | undefined): void {
    this.showVenueBookingProfile = hasBookingVenueCustomerAccount(user as any);
    this.showUserProfile =
      hasMusicianAccountProfile(user as any) ||
      hasBookingIndividualCustomerAccount(user as any) ||
      !this.showVenueBookingProfile;
    this.cdr.markForCheck();
  }
}
